const {setIn, extendIn} = require("../../../shared/ImmHelpers");

// Transformations of the node tree done right after parsing is finished and
// before returning it to CanvasMath. Does things like replace simple blanks
// with exp blanks if they are in a superscript tag. The updates are done
// immutably.

// Find all superscriptUnattached nodes among children and change them to
// appropriate superscripts. Returns node with modified children, or original
// node if no changes needed.
const attachSuperscripts = function(node, state) {
	if (
		!node.children ||
		!node.children.some(n => n.type === "superscriptUnattached")
	) {
		return node;
	}

	// If exponent is first in children, this is the node used as its base.
	const makePlaceholderNode = () => ({type: "text", text: ""});

	const newChildren = [];
	for (let i = 0; i < node.children.length; i += 1) {
		const child = node.children[i];
		if (child.type === "superscriptUnattached") {
			const prevChild = newChildren.pop() || makePlaceholderNode();
			newChildren.push({
				type: "superscript",
				children: [prevChild, child.children[0]],
			});
		} else {
			newChildren.push(child);
		}
	}
	return setIn(node, "children", newChildren);
};

// state is an arbitrary object that can track data about previously visited
// nodes if needed.
const transform = function(node, state = {}) {
	// TODO: use visitor pattern here if transforms get complicated.
	if (!node) {
		return node;
	}

	node = attachSuperscripts(node, state);

	// Set simple blanks to exp in exponents.
	if (node.type === "superscript") {
		state = setIn(state, "superscript", true);
	}
	if (
		node.type === "blank" &&
		node.blankType === "simple" &&
		state.superscript
	) {
		node = setIn(node, "isExponent", true);
	}

	// Recursively transform all children
	if (Array.isArray(node.children) && node.children.length) {
		node = setIn(node, "children", children => {
			return extendIn(
				children,
				[],
				children.map(child => transform(child, state))
			);
		});
	} else if (Array.isArray(node.listData) && node.listData.length) {
		node = setIn(node, "listData", listData => {
			return extendIn(
				listData,
				[],
				listData.map(child => transform(child, state))
			);
		});
	}
	return node;
};

module.exports = {
	transform,
};
